module.exports = __webpack_public_path__ + "static/media/hirurski_laser.f0a2da4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/devices/hirurski_laser.jpg
// module id = 406
// module chunks = 0